import { connect } from 'react-redux';
import { usersFirstName, botMessages, botMessagesLoading, currentStore } from 'core/selectors';
import { getBotMessages } from 'core/slices/bot_messages';
import HomeHeader from '../../../components/home/HomeHeader';

const mapStateToProps = state => ({
  firstName: usersFirstName(state),
  botMessages: botMessages(state),
  botMessagesLoading: !currentStore(state) || botMessagesLoading(state),
  currentStore: currentStore(state),
});

export default connect(mapStateToProps, { getBotMessages })(HomeHeader);
